import * as c from '../constants/filemanager';
import { apiAction, gdlAction } from '../actions/api';
import { loadContenders } from './simulation';
import { PAGE_ENGINEERING, PAGE_SIMULATION } from '../constants/pages';
import { setMainPage } from '../actions/app';
import { clearWorkAreas } from '../actions/engineering';
import { setSimulationSlot } from '../actions/simulation';

export const openFileManager = () => (dispatch, getState) => {
  dispatch({ type: c.FM_SHOW });
  const initialized = getState().filemanager.initialized;

  if (!initialized) {
    dispatch(loadConcepts());
  }
};

export const closeFileManager = () => ({
  type: c.FM_HIDE,
});

export const selectMenu = (menu) => ({
  type: c.FM_SELECT_MENU,
  menu,
});

export const loadConcepts = () => (dispatch) => {
  dispatch(
    apiAction(
      [
        c.FM_LOAD_CONCEPTS,
        c.FM_LOAD_CONCEPTS_SUCCESS,
        c.FM_LOAD_CONCEPTS_FAILURE,
      ],
      (api) => api.getConcepts()
    )
  );
};

export const autoSave = () => (dispatch, getState) => {
  const { workingConcept: name, isDirty } = getState().filemanager;
  if (!name || !isDirty) {
    return; // can't autosave without a working concept, or no need to save if there are no changes
  }

  dispatch(
    gdlAction(
      [
        c.FM_SAVE_REVISION,
        c.FM_SAVE_REVISION_SUCCESS,
        c.FM_SAVE_REVISION_FAILURE,
      ],
      (api) => api.saveRevision(false, '', name),
      { enterCompetition: false, comments: '', name, autoSave: true }
    )
  );
};

export const saveRevision = (enterCompetition, comments, name, gotoComp) => (
  dispatch
) => {
  dispatch(
    gdlAction(
      [
        c.FM_SAVE_REVISION,
        c.FM_SAVE_REVISION_SUCCESS,
        c.FM_SAVE_REVISION_FAILURE,
      ],
      (api) => api.saveRevision(enterCompetition, comments, name),
      { enterCompetition, comments, name, autoSave: false }
    )
  ).then((data) => {
    dispatch(clearWorkAreas());
    dispatch(loadConcepts());

    if (enterCompetition) {
      dispatch(loadContenders());

      if (gotoComp) {
        dispatch(setMainPage(PAGE_SIMULATION));
        dispatch(setSimulationSlot(1, data.designId, name));
        dispatch(setSimulationSlot(2));
      }
    }
  });
};

export const openRevision = (id, name) => (dispatch, getState) => {
  const {
    app: { page },
    auth: { studentId, groupId },
  } = getState();

  dispatch(
    gdlAction(
      [
        c.FM_OPEN_REVISION,
        c.FM_OPEN_REVISION_SUCCESS,
        c.FM_OPEN_REVISION_FAILURE,
      ],
      (api) => api.openRevision(id, name, studentId, groupId),
      { id, name }
    )
  ).then(() => {
    if (page !== PAGE_ENGINEERING) {
      dispatch(setMainPage(PAGE_ENGINEERING));
    }
    dispatch(clearWorkAreas());
  });
};

export const newConcept = (name) => async (dispatch) => {
  await dispatch(
    gdlAction(
      [c.FM_NEW_CONCEPT, c.FM_NEW_CONCEPT_SUCCESS, c.FM_NEW_CONCEPT_FAILURE],
      (api) => api.newConcept()
    )
  );
  dispatch(saveRevision(false, '', name));
};

export const forkConcept = (id, name) => async (dispatch) => {
  dispatch(
    apiAction(
      [c.FM_FORK_CONCEPT, c.FM_FORK_CONCEPT_SUCCESS, c.FM_FORK_CONCEPT_FAILURE],
      (api) => api.forkConcept(id, name)
    )
  ).then((data) => {
    dispatch(openRevision(data.design.id, data.design.name));
    dispatch(loadConcepts());
  });
};

export const toggleSharedConcept = (name, shared) => async (dispatch) => {
  dispatch(
    apiAction(
      [
        c.FM_TOGGLE_SHARED_CONCEPT,
        c.FM_TOGGLE_SHARED_CONCEPT_SUCCESS,
        c.FM_TOGGLE_SHARED_CONCEPT_FAILURE,
      ],
      (api) => api.toggleSharedConcept(name, shared)
    )
  )
    .then((data) => {
      dispatch(loadConcepts());
    })
    .catch((err) => {
      // Ignore (will have already been caught by middleware)
    });
};

export const saveNotes = (revision, notes) => (dispatch) => {
  dispatch(
    apiAction(
      [c.FM_SAVE_NOTES, c.FM_SAVE_NOTES_SUCCESS, c.FM_SAVE_NOTES_FAILURE],
      (api) => api.saveNotes(revision, notes)
    )
  );
};
